module.exports = __webpack_public_path__ + "static/media/customer-coffee-bean.3df93407.png";